import { render, staticRenderFns } from "./DashInventoryList.vue?vue&type=template&id=bd037e2c&scoped=true&"
import script from "./DashInventoryList.vue?vue&type=script&lang=js&"
export * from "./DashInventoryList.vue?vue&type=script&lang=js&"
import style0 from "./DashInventoryList.vue?vue&type=style&index=0&id=bd037e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd037e2c",
  null
  
)

export default component.exports